import { LatLongIcon } from '@rsos/assets/icons';
import { useChatContext } from '../ChatContext';
import { IconButton } from './IconButton';

export const TranslationMenuButton = () => {
  const { isTranslationMenuOpen, openTranslationMenu } = useChatContext();

  return (
    <IconButton
      data-name="chat-translation-menu-button"
      title="Translation menu"
      active={isTranslationMenuOpen}
      onClick={() => openTranslationMenu(!isTranslationMenuOpen)}
    >
      <LatLongIcon width={14} height={14} color="secondaryText" />
    </IconButton>
  );
};
